module.exports = __webpack_public_path__ + "static/media/facebook.4a9de12a.svg";